export default {
      id: "solarFluxDensity-usage",
      viewBox: "0 0 17.111 13.394",
      url: __webpack_public_path__ + "img/icons.df114aed.svg#solarFluxDensity",
      toString: function () {
        return this.url;
      }
    }